import { apiService } from "api/apiService";
import type { ClassroomMentorClass, ClassroomStudent } from "classroom/types";
import { mentorClassFromDto, classroomStudentFromDto } from "classroom/mappers";
import type {
  ClassroomStudentResource,
  MyStudentsShow200,
  MyStudentsStudents200,
} from "api/generated";

export const fetchMentorClass = async (
  mentorClass: string,
  signal?: AbortSignal,
): Promise<ClassroomMentorClass> => {
  const url = `/api/my-students/${encodeURIComponent(mentorClass)}`;

  const { data } = await apiService.get<MyStudentsShow200>(url, { signal });

  return mentorClassFromDto(data.data);
};

export const fetchMentorClassStudents = async (
  mentorClass: string,
  search: string | null = null,
  signal?: AbortSignal,
): Promise<ClassroomStudent[]> => {
  const url = `/api/my-students/${encodeURIComponent(mentorClass)}/students`;
  const params = search !== null && search.length > 0 ? { search } : {};

  const { data } = await apiService.get<MyStudentsStudents200>(url, {
    params,
    signal,
  });

  return data.data.map((studentData: ClassroomStudentResource) =>
    classroomStudentFromDto(studentData),
  );
};
